hostnamePartStart